// Module
var code = "<i class=\"icon-X\" ng-click=\"amTableCtrl.remove(rowObj)\"></i>";
// Exports
module.exports = code;